import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';

class FatalErrorMessage extends React.Component {
  render() {
    const {
      t,
      message,
    } = this.props;

    return (
      <div style={{ textAlign: 'center', padding: '80px 20px' }}>
        <p>{message || t('Sorry, something has gone wrong. Please reload the app.')}</p>
        <Button onClick={() => {
          window.location.reload();
        }} color="primary">
          {t('Reload App')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(FatalErrorMessage);
